@if (remoteContent$ | async; as content) {
<div class="container">
  <div class="row">
    <section class="col-md-7">
      <app-risk-flow-risk-result
      [config]="{
        consumerId: 'GC',
        flow: 'CWP',
        clientType: 'CLIENT'
      }"
      (riskPreferenceHandler)="riskAttitudeChanged($event)"
      (retakingRiskQuizHandler)="retakingRiskQuizHandler()"
      (errorHandler)="errorHandler($event)"
      >
      </app-risk-flow-risk-result>
      <onb-mfe-secure-link></onb-mfe-secure-link>
    </section>
    <div class="col-md-1"></div>
      <section class="col-md-4">
        <c11n-button id="riskQuizResultsContinueBTN" [labelText]="content?.continueButton || 'Continue'" [fullWidth]="true"
          (clickEvent)="continue()"></c11n-button>
        <app-cancel [isOpenChoice]="true"></app-cancel>
        <app-feedback-survey></app-feedback-survey>
      </section>
  </div>
</div>
}
